(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var Menu = function Menu() {
        this.burgerMenu = document.getElementById('burgerMenu');
        this.megamenu = document.getElementById('megamenu');
        this.logoHeader = document.getElementById('logoHeader');
        this.shortMenu = document.getElementById('short-menu');
        this.header = document.getElementById('header');

        // Initialisation de l'état du menu
        this.isOpen = false;

        // Bind des méthodes pour garantir le bon contexte
        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        // Initialisation des événements
        this.initializeEvents();
    };

    Menu.prototype.initializeEvents = function initializeEvents () {
        // Gestion du clic sur le menu burger
        this.burgerMenu.addEventListener('click', this.toggleMenu);

        // Gestion de l'interaction clavier (Entrée ou Espace)
        this.burgerMenu.addEventListener('keydown', this.handleKeydown);
    };

    // Méthode pour basculer l'état du menu (ouvert/fermé)
    Menu.prototype.toggleMenu = function toggleMenu () {
        // Basculer l'état ouvert/fermé
        this.isOpen = !this.isOpen;

        // Toggle des classes pour les animations/transformations
        this.burgerMenu.classList.toggle('active', this.isOpen);
        this.logoHeader.classList.toggle('is-hidden', this.isOpen);
        this.shortMenu.classList.toggle('is-hidden', this.isOpen);
        this.header.classList.toggle('is-fixed', this.isOpen);
        this.megamenu.classList.toggle('open', this.isOpen);

        // Mise à jour des attributs aria
        this.megamenu.setAttribute('aria-hidden', !this.isOpen);
        this.burgerMenu.setAttribute('aria-expanded', this.isOpen);
    };

    // Gestion des interactions clavier
    Menu.prototype.handleKeydown = function handleKeydown (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Empêcher les comportements par défaut comme le défilement avec Espace
            this.toggleMenu();
        }
    };

    var Theme = function Theme() {
        this.currentFontSizePercent = 62.5;
        this.minFontSizePercent = 32.5;
        this.maxFontSizePercent = 92.5;

        this.initializeEvents();
        this.initializeTheme();

        this.article = document.querySelector('.article');
        this.author = document.querySelector('.article-container__author');
        this.baseColumnSize = 25;
    };

    Theme.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        var themeButton = document.querySelector('.theme__color-btn');
        themeButton.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.changeThemeColors();
        });

        var themeFontDecrease = document.querySelector('.theme__font-btn-decrease');
        themeFontDecrease.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.decreaseFontSize();
        });

        var themeFontIncrease = document.querySelector('.theme__font-btn-increase');
        themeFontIncrease.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.increaseFontSize();
        });
    };

    Theme.prototype.initializeTheme = function initializeTheme () {
        var savedMode = localStorage.getItem('themeMode') || 'dark';
        this.applyTheme(savedMode);
    };

    Theme.prototype.applyTheme = function applyTheme (mode) {
        var body = document.body;
        body.classList.toggle('light-mode', mode === 'light');

        // = Effects
        // -----------------------------
        document.querySelectorAll('.glitch img').forEach(function (element) {
            element.classList.toggle('img-light-mode', mode === 'light');
        });
    };

    Theme.prototype.changeThemeColors = function changeThemeColors () {
        var currentMode = localStorage.getItem('themeMode') || 'dark';
        var newMode = currentMode === 'dark' ? 'light' : 'dark';
        localStorage.setItem('themeMode', newMode);
        this.applyTheme(newMode);
    };

    Theme.prototype.increaseFontSize = function increaseFontSize () {
        if (this.currentFontSizePercent + 10 <= this.maxFontSizePercent) {
            this.currentFontSizePercent += 10;
            this.applyFontSize();
            this.adjustGridColumns();
        }
    };

    Theme.prototype.decreaseFontSize = function decreaseFontSize () {
        if (this.currentFontSizePercent - 10 >= this.minFontSizePercent) {
            this.currentFontSizePercent -= 10;
            this.applyFontSize();
            this.adjustGridColumns();
        }
    };

    Theme.prototype.applyFontSize = function applyFontSize () {
        document.body.style.fontSize = (this.currentFontSizePercent) + "%";
        document.documentElement.style.fontSize = (this.currentFontSizePercent) + "%";
    };

    var Ecoindex = function Ecoindex() {
        this.SCROLL_THRESHOLD_START = 1000;
        this.SCROLL_THRESHOLD_END = 1200;
        this.initializeEvents();
    };

    Ecoindex.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        window.addEventListener('scroll', function () {
            var ecoindexBadge = document.getElementById('ecoindex-badge');
            var opacity = 1;
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition >= this$1.SCROLL_THRESHOLD_START && scrollPosition <= this$1.SCROLL_THRESHOLD_END) {
                opacity = 1 - ((scrollPosition - this$1.SCROLL_THRESHOLD_START) / (this$1.SCROLL_THRESHOLD_END - this$1.SCROLL_THRESHOLD_START));
            } else if (scrollPosition > this$1.SCROLL_THRESHOLD_END) {
                opacity = 0;
            }

            if (ecoindexBadge) {
                ecoindexBadge.style.opacity = opacity;
                ecoindexBadge.style.pointerEvents = opacity === 0 ? 'none' : 'auto';
            }
        });
    };

    var Social = function Social() {
        this.initializeEvents();
    };

    Social.prototype.initializeEvents = function initializeEvents () {
        var copyUrlButton = document.querySelector('.social-logo .link');
        var tooltip = document.querySelector(".tooltiptext");
        if (copyUrlButton) {
            copyUrlButton.addEventListener("click", function (event) {
                event.preventDefault();
                var urlStr = window.location.href.toString();
                navigator.clipboard.writeText(urlStr);
                tooltip.innerHTML = "URL copied";
            });
            copyUrlButton.addEventListener("mouseout", function (event) {
                event.preventDefault();
                tooltip.innerHTML = "Copy URL link";
            });
        }
    };

    var Formation = function Formation() {
        this.scrollY = 0;
        this.initializeEvents();
    };

    Formation.prototype.initializeEvents = function initializeEvents () {
        var self = this;
        var actionBanner = document.querySelector('.detailed-template-action');
        var footerContainer = document.querySelector('footer .container--full');
        window.onscroll = function () {
            self.scrollY = window.scrollY;
            var cssClass = 'is-displayed';
            var scrollLength = 700;
            if (self.scrollY >= scrollLength && actionBanner && !actionBanner.classList.contains(cssClass)) {
                actionBanner.classList.add(cssClass);
                footerContainer.style.marginBottom = "7rem";
            } else if (self.scrollY < scrollLength && actionBanner && actionBanner.classList.contains(cssClass)) {
                actionBanner.classList.remove(cssClass);
                footerContainer.style.marginBottom = "0";
            }
        };

        // Subscribe formation buttons
        document.querySelectorAll('button.register-formation').forEach(function (element) {
            element.addEventListener("click", function (event) {
                event.preventDefault();
                window.open("/contact?form=form4&formation=" + element.getAttribute('data-formation'), '_self');
            });
        });
    };

    var Contact = function Contact() {
        this.initializeEvents();
    };

    Contact.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        var meetingBtns = document.querySelectorAll('.meeting');
        meetingBtns.forEach(function (btn) {
            btn.addEventListener('click', this$1.toggleMeeting);
        });

        document.querySelectorAll('textarea').forEach(function (textarea) {
            var label = textarea.nextElementSibling;

            if (textarea.value.trim() !== '') {
                label.classList.add('active');
            }

            textarea.addEventListener('input', function () {
                if (textarea.value.trim() !== '') {
                    label.classList.add('active');
                } else {
                    label.classList.remove('active');
                }
            });
        });

    };

    Contact.prototype.toggleMeeting = function toggleMeeting () {
        var meetingBlock = document.querySelector('.meeting-block');
        meetingBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    var Home = function Home() {
        this.initializeEvents();
    };

    Home.prototype.initializeEvents = function initializeEvents () {
        if (window.innerWidth > 768) {
            // If touch-screen (mobile) device, create double tap event on homepage blocs
            if ("ontouchstart" in document.documentElement) {
                var knowMoreLink = '.discover__grid a.know-more';
                var classVisible = 'is-visible';
                document.querySelectorAll('.discover__grid a.discover').forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        document.querySelectorAll(knowMoreLink).forEach(function (more) {
                            more.classList.remove(classVisible);
                        });
                        element.nextSibling.nextSibling.classList.add(classVisible);
                    });
                });
                document.querySelectorAll(knowMoreLink).forEach(function (more) {
                    more.addEventListener('click', function (event) {
                        more.classList.remove(classVisible);
                    });
                });

                // Ajoute un gestionnaire d'événements sur le document pour gérer les clics en dehors des éléments 'discover'
                document.addEventListener('click', function (event) {
                    var target = event.target; // L'élément qui a été cliqué
                    var isDiscoverElementClicked = target.closest('.discover__grid a.discover') || target.closest(knowMoreLink);

                    // Si l'élément cliqué n'est pas un élément 'discover' ni un lien 'en savoir plus'
                    if (!isDiscoverElementClicked) {
                        // Retire la classe 'is-visible' de tous les éléments 'en savoir plus'
                        document.querySelectorAll(knowMoreLink).forEach(function (more) {
                            more.classList.remove(classVisible);
                        });
                    }
                });
            }
        }
    };

    var Accessibility = function Accessibility() {
        this.initializeEvents();
    };

    Accessibility.prototype.initializeEvents = function initializeEvents () {

    };


    var toggleDyslexic = document.getElementById('toggleDyslexic');
    var toggleColor = document.getElementById('toggleColor');
    var bodyElement = document.body;

    // Fonction pour appliquer la police en fonction de l'état
    function applyFont(isOn) {
        if (isOn) {
            bodyElement.classList.add('dyslexic-font');
            toggleDyslexic.checked = true;
        } else {
            bodyElement.classList.remove('dyslexic-font');
            toggleDyslexic.checked = false;
        }
    }

    // Vérifier si une valeur est déjà stockée dans le localStorage
    var savedFontPreference = localStorage.getItem('fontPreference');
    if (savedFontPreference) {
        applyFont(savedFontPreference === 'true');
    }

    // Ajout d'un événement clavier pour activer/désactiver la police
    toggleDyslexic.addEventListener('change', function () {
        var isOn = this.checked;
        applyFont(isOn);
        localStorage.setItem('fontPreference', isOn);
    });

    toggleDyslexic.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Empêche le comportement par défaut de "Espace"
            this.checked = !this.checked; // Inverse l'état du bouton
            var isOn = this.checked;
            applyFont(isOn);
            localStorage.setItem('fontPreference', isOn);
        }
    });

    // Fonction pour appliquer la couleur en fonction de l'état
    function applyColor(isOn) {
        if (isOn) {
            bodyElement.classList.add('color-contrast');
            toggleColor.checked = true;
        } else {
            bodyElement.classList.remove('color-contrast');
            toggleColor.checked = false;
        }
    }

    var savedColorPreference = localStorage.getItem('colorPreference');
    if (savedColorPreference) {
        applyColor(savedColorPreference === 'true');
    }

    // Ajout d'un événement clavier pour activer/désactiver le contraste
    toggleColor.addEventListener('change', function () {
        var isOn = this.checked;
        applyColor(isOn);
        localStorage.setItem('colorPreference', isOn);
    });

    toggleColor.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Empêche le comportement par défaut de "Espace"
            this.checked = !this.checked; // Inverse l'état du bouton
            var isOn = this.checked;
            applyColor(isOn);
            localStorage.setItem('colorPreference', isOn);
        }
    });

    var toggleAccessibility = document.getElementById('toggleAccessibility');
    var menuVisible = true;


    // Fonction pour faire apparaitre le menu d'accessibilité

    toggleAccessibility.addEventListener('click', toggleMenu);
    toggleAccessibility.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleMenu();
        }
    });

    function toggleMenu() {
        if (menuVisible) {
            bodyElement.classList.add('accessibility--open');
            menuVisible = false;
        } else {
            bodyElement.classList.remove('accessibility--open');
            menuVisible = true;
        }
    }

    var ShortMenu = function ShortMenu() {
        this.body = document.body;
        this.triggerMenu = document.querySelector(".header");
        this.scrollUp = "scroll-up";
        this.scrollDown = "scroll-down";
        this.lastScroll = 0;
        this.scrollThreshold = 80; // Seuil en pixels avant de déclencher les événements

        // Initialisation des événements
        this.initializeEvents();
    };

    ShortMenu.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        window.addEventListener("scroll", function () { return this$1.handleScroll(); });
    };

    ShortMenu.prototype.handleScroll = function handleScroll () {
        var currentScroll = window.scrollY;

        // Vérifier si la classe "is-fixed" est présente sur la div "header"
        if (this.triggerMenu.classList.contains("is-fixed")) {
            // Si "is-fixed" est présent, ne pas exécuter les actions
            return;
        }

        // Ne rien faire si le défilement est inférieur au seuil
        if (currentScroll < this.scrollThreshold) {
            this.body.classList.remove(this.scrollUp, this.scrollDown);
            return;
        }

        if (currentScroll > this.lastScroll && !this.body.classList.contains(this.scrollDown)) {
            // Scrolling down
            this.body.classList.remove(this.scrollUp);
            this.body.classList.add(this.scrollDown);
        } else if (
            currentScroll < this.lastScroll &&
            this.body.classList.contains(this.scrollDown)
        ) {
            // Scrolling up
            this.body.classList.remove(this.scrollDown);
            this.body.classList.add(this.scrollUp);
        }

        this.lastScroll = currentScroll;
    };

    document.addEventListener('DOMContentLoaded', function () {
        new Menu();
        new Theme();
        new Home();
        new Ecoindex();
        new Social();
        new Formation();
        new Accessibility();
        new ShortMenu();
        // Vérifiez si l'URL contient 'contact'
        var isContactUrl = window.location.href.includes('contact');

        // Vérifiez si un élément avec la classe 'contact' existe sur la page
        var contactElementExists = document.querySelector('.contact') !== null;

        // Si l'une des conditions est vraie, créez une nouvelle instance de Contact
        if (isContactUrl || contactElementExists) {
            new Contact();
        }
    });

})));
//# sourceMappingURL=main.min.js.map
